// ─────────────────────────────────────────────
//  share.js — Compartir enlace de la app
// ─────────────────────────────────────────────

export const APP_SHARE_URL = 'https://tips.aerremedia.com';
export const APP_SHARE_TITLE = 'AR Cuánto';
export const APP_SHARE_MESSAGE =
	'Te recomiendo AR Cuánto — calculadoras prácticas para propinas, porcentajes y más.';

export function getShareText() {
	return `${APP_SHARE_MESSAGE}\n${APP_SHARE_URL}`;
}

export function canNativeShare() {
	return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export function shareWhatsApp() {
	const message = getShareText();
	window.open(
		`https://wa.me/?text=${encodeURIComponent(message)}`,
		'_blank',
		'noopener,noreferrer'
	);
}

export function shareTelegram() {
	window.open(
		`https://t.me/share/url?url=${encodeURIComponent(APP_SHARE_URL)}&text=${encodeURIComponent(APP_SHARE_MESSAGE)}`,
		'_blank',
		'noopener,noreferrer'
	);
}

export function shareMessenger() {
	const link = encodeURIComponent(APP_SHARE_URL);
	const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');

	if (isMobile) {
		window.open(`fb-messenger://share?link=${link}`, '_blank', 'noopener,noreferrer');
		return;
	}

	window.open(
		`https://www.facebook.com/sharer/sharer.php?u=${link}&quote=${encodeURIComponent(APP_SHARE_MESSAGE)}`,
		'_blank',
		'noopener,noreferrer'
	);
}

function canSharePayload(data) {
	if (typeof navigator.canShare !== 'function') return true;
	try {
		return navigator.canShare(data);
	} catch {
		return false;
	}
}

async function tryNativeShare() {
	if (!canNativeShare()) return false;

	const payloads = [
		{ url: APP_SHARE_URL, title: APP_SHARE_TITLE, text: APP_SHARE_MESSAGE },
		{ url: APP_SHARE_URL, title: APP_SHARE_TITLE },
		{ url: APP_SHARE_URL },
		{ title: APP_SHARE_TITLE, text: getShareText() },
		{ text: getShareText() },
	];

	for (const data of payloads) {
		if (!canSharePayload(data)) continue;

		try {
			await navigator.share(data);
			return true;
		} catch (err) {
			if (err?.name === 'AbortError') throw err;
		}
	}

	return false;
}

async function copyToClipboard(text) {
	if (navigator.clipboard?.writeText && window.isSecureContext) {
		try {
			await navigator.clipboard.writeText(text);
			return true;
		} catch {
			// fallback below
		}
	}

	try {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.top = '0';
		textarea.style.left = '0';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		textarea.setSelectionRange(0, text.length);
		const copied = document.execCommand('copy');
		document.body.removeChild(textarea);
		return copied;
	} catch {
		return false;
	}
}

export async function shareNative() {
	try {
		if (await tryNativeShare()) return 'shared';
	} catch (err) {
		if (err?.name === 'AbortError') throw err;
	}

	if (await copyToClipboard(APP_SHARE_URL)) return 'copied';

	return 'failed';
}
